<template>
    <div>
        <div class="container">
            <div class="row">
                <title-area :title="this.$t('sistemi_prokurorial.page.professional_ethics.title')"/>
                <p>
                    {{ this.$t('sistemi_prokurorial.page.professional_ethics.description') }}
                </p>
                <h3 class="text-decoration-underline">
                    {{ this.$t('sistemi_prokurorial.page.professional_ethics.secondTitle') }}
                </h3>
            </div>
        </div>
    </div>
</template>
<script>
import TitleArea from '../share/TitleArea.vue'

export default {
  components: { TitleArea },
    return(){
        return{
            aaa:"Etika Profesionale"
        }
    },
    compoennts:{
        TitleArea
    }
}
</script>
<style scoped>
    p{
        color:#101826;
        font-size:16px;
    }

    h3{
        color:#101826;
    }
</style>